import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { AddressIcon } from "../../../../Icons/AddressIcon";
import { CurrencyIcon } from "../../../../Icons/CurrencyIcon";
import { GetTimeZone } from "../../../../_utilities/GetTimeZone";
import { GetUserId, GetUserInfo } from "../../../../_utilities/getUserInfo";
import { JobpostingIcon } from "../../../../Icons/JobpostingIcon";
import * as _ser from "../../../../_redux/_services/JobPostingSlice";
import { customFieldsAsync } from "../../../../_redux/_services/UserManagerSlice";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import {
  Box,
  Typography,
  IconButton,
  Tab,
  Divider,
  Tooltip,
} from "@mui/material";
import JobpostingDetailsAuditlogging from "../JobpostingDetailsAuditlogging/JobpostingDetailsAuditlogging";
import {
  resetSelectedJobPosting,
  setSelectedJobPosting,
} from "../../../../_redux/SelectedJobPostingSlice";
import { Encrypt } from "../../../../_utilities/_encryptDecryptHelper";
import { updateLoader } from "../../../../_redux/LoaderSlice";
import { Clone } from "../../../../Icons/Clone";
import { ApplicantEdit } from "../../../../Icons/ApplicantEdit";
import WarningPopup from "../../../../components/WarningPopup/WarningPopup";
import { warningPopups } from "../../../../constants/constants";
import JobpostingDetailsNotes from "../JobpostingDetailsNotes/JobpostingDetailsNotes";
import JobpostingDetailsPortalsView from "../JobpostingDetailsPortals/JobpostingDetailsPortalsView";
import ScreeningQuestions from "../JobpostingDetailsScreeningQuestions/ScreeningQuestions";
import JobpostingDetailsDocuments from "../JobpostingDetailsDocuments/JobpostingDetailsDocuments";
import JobpostingDetailsOverview from "../JobpostingDetailsOverview/JobpostingDetailsOverview";
import JobpostingDetailsEdit from "../JobpostingDetailsEdit/JobpostingDetailsEdit";
import {
  getValueUtilitie,
  parseSkills,
} from "../../../../_utilities/utilities";
import JobpostingAssociatedApplicants from "../JobpostingDetailsAssociatedApplicants/JobpostingAssociatedApplicants";
import { JobpostingDetailsMenuOptions } from "../../../../constants/floatingMenuConstants";
import FloatingMenu from "../../../../components/FloatingMenu/FloatingMenu";
import { toggleSidebar } from "../../../../_redux/Uislice";
import { updateNextPath } from "../../../../_redux/SelectedNextPath";

const initalState = { data: null, message: "", isloader: true };

const JobpostingDetailsTabs = ({ onResetTabs, onReceiveProps, moduleType = "default" }) => {
  const [tab, setTab] = useState("jobdetails");
  const [document, setDocuments] = useState([]);
  const [accociatedApplicantList, setAccociatedAppliantList] = useState([]);
  const [notesData, setNotesData] = useState([]);
  const [savedJobPosting, setSavedJobPosting] = useState(null);
  const [savedJobCode, setSavedJobCode] = useState(null);
  const [auditlogData, setAuditlogData] = useState([]);
  const [JobpostingDetails, setJobpostingDetails] = useState(null);
  const [showEditJobDetails, setShowEditJobDetails] = useState(false);
  const [recruiterObj, setRecruiterObj] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [open, setOpen] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const navigate = useNavigate();
  const { search } = useLocation();
  const dispatch = useDispatch();

  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";
  const { storedJobPostingId, storedJobCode } = useSelector(
    (state) => state.SelectedJobPosting,
  );
  const { data: questionsData, code: questionStatus } = useSelector(
    (state) => state.GetQuestionsList,
  );
  const getDetails = useSelector((state) => state.Jobpostingsbyid.data);
  const docData = useSelector((state) => state.Getdocuments.data);
  const AccociatedApplicantsData = useSelector(
    (state) => state.GetAssociatedApplicants.data,
  );
  const notesResponse = useSelector((state) => state.Getnotes.data);
  const AuditlogResponse = useSelector(
    (state) => state.GetPostingsComments.data,
  );
  const recruiterList = useSelector(
    (state) => state.GetManagerTeamlead.recruiter,
  );

  const Deletejobpostingscode = useSelector(
    (state) => state.Deletejobpostings.data,
  );
  const isSidebarHidden = useSelector((state) => state.ui.isSidebarHidden);
  const customFieldsData = useSelector((state) => state.CustomFields.data);

  useEffect(() => {
    if (Boolean(onResetTabs)) {
      setTab("jobdetails");

    }
  }, [onResetTabs]);

  useEffect(() => {
    const params = new URLSearchParams(search);
    const page = params.get("tab");
    if (page) {
      setTab(page);
    }
  }, [search]);

  useEffect(() => {
    fetchDataAsync();
  }, []);

  const fetchDataAsync = async () => {
    let userId = await GetUserId();
    if (userId) {
      dispatch(_ser.getManagerTeamleadAsync(" ", userId));
    }
  };

  useEffect(() => {
    if (recruiterList && recruiterList.length > 0) {
      const data = JSON.parse(JSON.stringify(recruiterList));
      let newArray = [];
      data.forEach((list) => {
        let obj = {
          id: list.id.toString(),
          name: `${list.firstName} ${list.lastName}`,
          emailId: list.emailId,
        };
        newArray.push(obj);
      });
      setRecruiterObj(newArray);
    } else {
      fetchDataAsync();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, recruiterList]);

  useEffect(
    () => {
      if (storedJobPostingId !== null) {
        setShowEditJobDetails(false);
        setDocuments([]);
        setAccociatedAppliantList([]);
        setAuditlogData([]);
        setNotesData([]);
        setSavedJobPosting(storedJobPostingId);
        GetData(storedJobPostingId);
      }
      if (storedJobCode !== null) {
        setSavedJobCode(storedJobCode);
      }
    },
    [storedJobPostingId, storedJobCode]
  );

  const GetData = async (id) => {
    const userId = await GetUserId();
    dispatch(customFieldsAsync(userId));
    dispatch(_ser.getListSegmentsAsync());
    dispatch(_ser.jobpostingsbyidAsync(id));
    dispatch(_ser.getdocumentsAsync(id));
    dispatch(_ser.getAssociatedApplicantsAsync(id));
    dispatch(_ser.getnotesAsync(id));
    dispatch(_ser.getQuestionsListAsync(id));
    let obj = { type: "jobopening", typeId: id };
    dispatch(_ser.getPostingsCommentsAsync(obj));
  };

  const onRenderComponentHandler = (type, state) => {
    onReceiveProps("changeAppliant");
    if (type === "loadApplicant") {
      onReceiveProps("reload");
      setShowEditJobDetails(false);
      dispatch(
        setSelectedJobPosting({
          storedJobPostingId: savedJobPosting,
          storedJobCode: savedJobCode,
        }),
      );
      dispatch(_ser.jobpostingsbyidAsync(savedJobPosting));
    } else if (type === "notes") {
      dispatch(_ser.getnotesAsync(savedJobPosting));
    } else if (type === "documents") {
      dispatch(_ser.getdocumentsAsync(savedJobPosting));
    } else if (type === "clear") {
      onCloseHandler();
    } else if (type === "edit") {
      setTimeout(() => {
        setShowEditJobDetails(true);
      }, 500);
    } else if (type === "associateApplicant") {
      setAccociatedAppliantList([]);
      dispatch(_ser.getAssociatedApplicantsAsync(savedJobPosting));
    } else if (state === "auditinfo") {
      let obj = { type: "jobopening", typeId: savedJobPosting };
      dispatch(_ser.getPostingsCommentsAsync(obj));
    }
  };

  useEffect(() => {
    if (getDetails && customFieldsData?.length > 0) {
      let postingData = JSON.parse(JSON.stringify(getDetails));
      postingData.jobType = postingData.jobType.split(",");
      postingData.recruiters = postingData.recruiters
        ? JSON.parse(postingData.recruiters)
        : [];
      if (customFieldsData.length > 0) {
        let postingCustomFields = postingData.customFields
          ? JSON.parse(postingData.customFields)
          : [];
        let postFields = [];
        customFieldsData.forEach((element) => {
          if(element?.moduleId?.toString() === '1'){
            const field = postingCustomFields.find((item) => item?.key === element?.fieldName);
            if (field) {
              postFields.push({ ...field, mandatory: element.mandatory });
            }
          }
        });
        postingData.customFields = postFields;
      }
      postingData.clientName = {
        id: postingData.clientId,
        clientName: postingData.clientName,
      };
      let recruiterTeamObj = [
        {
          id: 1,
          key: "Manager",
          value: getValueUtilitie(
            "id",
            postingData.manager,
            recruiterObj,
            "name",
          ),
        },
        {
          id: 2,
          key: "Team Lead",
          value: getValueUtilitie(
            "id",
            postingData.teamLead,
            recruiterObj,
            "name",
          ),
        },
        {
          id: 3,
          key: "Recruiter",
          value: postingData.recruiters
            .map((r) => getValueUtilitie("id", r, recruiterObj, "name"))
            .join(", "),
        },
      ].filter((item) => item.value && item.value !== "");
      let additionInfoObj = postingData.customFields
        ?.map((field, index) => ({
          id: index + 1,
          key: field.key,
          value: field.value,
          mandatory: field.mandatory,
        }))
        .filter((item) => item.value && item.value !== "");
      postingData["recruiterTeam"] = recruiterTeamObj;
      postingData["additionInfo"] = additionInfoObj;
      postingData.primarySkills = postingData?.primarySkills
        ? parseSkills(postingData.primarySkills)
        : "";
      postingData.secondarySkills = postingData?.secondarySkills
        ? parseSkills(postingData.secondarySkills)
        : "";
      setJobpostingDetails(postingData);
      if (moduleType === "client" || moduleType === "projects") {
        dispatch(updateNextPath(`${postingData.jobTitle} (${postingData.jobCode})`));
      }
      setSavedJobCode(postingData.jobCode);
      let updateSkills = postingData?.primarySkills
        ? postingData.primarySkills.join(", ")
        : "";
      Encrypt(updateSkills, "getSkills");
      localStorage.setItem("JobIdentifier", postingData.affindaIdentifier);
    }
  }, [getDetails, customFieldsData, recruiterObj]);

  useEffect(() => {
    if (docData !== null) {
      if (docData.length > 0) {
        let documentsData = JSON.parse(JSON.stringify(docData));
        documentsData.forEach((list) => {
          if (list.docs !== "") {
            list.docs = JSON.parse(list.docs);
          } else {
            dispatch(updateLoader(false));
            return;
          }
        });
        let dataArray = [];
        if (documentsData.length > 0) {
          documentsData.forEach((e) => {
            if (typeof e.docs === "string") {
              e.docs = JSON.parse(e.docs);
            }
            const { docs } = e;
            dataArray.push(...docs);
          });
          dataArray.forEach((list) => {
            list.name = list.name.replaceAll("-", " ");
            list.date = GetTimeZone(list.date);
            list["total_count"] = dataArray.length;
          });
          setDocuments(dataArray.reverse());
        }
        dispatch(_ser.getdocumentsStartReducer(initalState));
      } else {
        setDocuments([]);
      }
    }
  }, [docData]);

  useEffect(() => {
    if (
      AccociatedApplicantsData !== null &&
      AccociatedApplicantsData !== undefined
    ) {
      if (AccociatedApplicantsData.length > 0) {
        const myData = JSON.parse(JSON.stringify(AccociatedApplicantsData));
        setAccociatedAppliantList(myData);
        dispatch(_ser.getAssociatedApplicantsStartReducer(initalState));
      } else {
        setAccociatedAppliantList([]);
      }
    }
  }, [AccociatedApplicantsData]);

  useEffect(() => {
    if (questionStatus === 200 && (questionsData?.length > 0 || questionsData?.length === 0)) {
      setQuestions(questionsData);
      dispatch(_ser.getQuestionsListStartReducer(initalState));
    }
  }, [questionsData, questionStatus, initalState]);
  
  useEffect(() => {
    if (notesResponse && notesResponse?.length > 0) {
      setNotesData(notesResponse);
      dispatch(_ser.getnotesStartReducer(initalState));
    }
  }, [notesResponse]);

  useEffect(() => {
    if (AuditlogResponse && AuditlogResponse.length > 0) {
      let auditlog = JSON.parse(JSON.stringify(AuditlogResponse));
      auditlog.forEach((item) => {
        item.createdAt = GetTimeZone(item.createdAt);
      });
      setAuditlogData(auditlog);
      dispatch(_ser.getPostingsCommentsStartReducer(initalState));
    }
  }, [AuditlogResponse]);

  const onCloseHandler = (status = "close") => {
    setSavedJobPosting(null);
    setSavedJobCode(null);
    setShowEditJobDetails(false);
    dispatch(resetSelectedJobPosting());
    onReceiveProps(status);
  };

  const handleConfirmClone = async () => {
    setOpen(false);
    if (savedJobPosting) {
      await dispatch(_ser.jobpostingsbyidAsync(savedJobPosting));
      await dispatch(_ser.getListofQuestionsAsync(savedJobPosting));
      navigate("/ats/layout/jobpostings/create/jobdetails");
    }
  };

  const onReceiveDataHandler = (data, isData, type) => {
    console.log("Received data from child component:", data, isData, type);
  };

  const onReceiveActionHandler = (action, isMain) => {
    if(action === 'delete'){
      setShowDeleteConfirm(true);
    } else if(action === 'clone'){
      setOpen(true);
    } else if(action === 'edit'){
      setShowEditJobDetails(true);
    }
  }

  const handleConfirmDelete = async () => {
    setShowDeleteConfirm(false);
    let obj = { ids: [savedJobPosting.toString()] };
    dispatch(_ser.deletejobpostingsAsync(obj));
  };

  useEffect(() => {
    if (Deletejobpostingscode === 200) {
      dispatch(_ser.deletejobpostingsStartReducer(initalState))
      onCloseHandler("deleted");
      dispatch(resetSelectedJobPosting());
    }
  }, [Deletejobpostingscode]);

  return (
    <Box
      sx={{ width: "100%", bgcolor: "#fff", borderRadius: 2 }}
      id="applicant-new"
    >
      {/* ========== MOBILE PROFILE VIEW ========== */}
      {isMobile ? (
        <Box className="mobile-profile-view" sx={{ px: 2, pb: 2 }}>
          {/* Back arrow */}
          <Box
            onClick={onCloseHandler}
            sx={{
              pt: 1.5,
              pb: 1,
              cursor: "pointer",
              display: "inline-flex",
            }}
          >
            <ChevronLeftIcon sx={{ fontSize: 24, color: "#555" }} />
          </Box>

          {/* Avatar */}
          <Box sx={{ width: 65, height: 65, mb: 1 }}>
            <JobpostingIcon
              primaryColor={storedTheme?.primaryColor}
              primaryFontColor={storedTheme?.primaryFontColor}
            />
          </Box>
          {JobpostingDetails && (
            <>
              {/* Name & subtitle */}
              <Typography
                variant="h6"
                fontWeight={600}
                sx={{ lineHeight: 1.3 }}
              >
                {JobpostingDetails?.jobTitle}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 0.3 }}
              >
                {JobpostingDetails?.clientName?.clientName}
              </Typography>
              {/* Contact info */}
              <Box
                sx={{
                  mt: 1.5,
                  display: "flex",
                  flexDirection: "column",
                  gap: 0.8,
                }}
              >
                 {JobpostingDetails?.location && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <AddressIcon style={{ flexShrink: 0, marginTop: "2px" }} />
                    <span style={{ fontSize: 14 }}>
                      {JobpostingDetails?.location}
                    </span>
                  </Box>
                )}
                {JobpostingDetails?.payBillRate && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <CurrencyIcon />
                    <span style={{ fontSize: 14 }}>
                      {JobpostingDetails?.payBillRate}
                    </span>
                  </Box>
                )}
              </Box>
            </>
          )}

          {/* Overview content directly - no tabs */}
          <Box sx={{ mt: 2 }}>
            {JobpostingDetails && (
              <JobpostingDetailsOverview
                selectedJob={savedJobPosting}
                jobDetails={JobpostingDetails}
              />
            )}
          </Box>
        </Box>
      ) : (
        <>
          {/* ========== DESKTOP VIEW (unchanged) ========== */}
          {/* Header */}
          <Box
            className="applicant-detail-header"
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              p: 2,
              gap: 2,
            }}
          >
            <Box sx={{ display: "flex", gap: 2, flex: 1, minWidth: 0 }}>
              <JobpostingIcon
                primaryColor={storedTheme?.primaryColor}
                primaryFontColor={storedTheme?.primaryFontColor}
              />
              {JobpostingDetails && (
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography
                    variant="h5"
                    fontWeight={600}
                    sx={{
                      wordBreak: "break-word",
                      overflowWrap: "anywhere",
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      paddingRight: showEditJobDetails ? "180px" : "0px",
                    }}
                  >
                    {JobpostingDetails?.jobTitle} ({JobpostingDetails?.jobCode})
                    <span className="clientJob-icons">
                      <img
                        src={isSidebarHidden ? "/ats/assests/img/minimiseIcon.svg" : "/ats/assests/img/expandIcon.svg"}
                        alt={isSidebarHidden ? "minimise icon" : "expand icon"}
                        style={{ width: "16px", marginLeft: "8px", marginBottom: "5px", cursor: "pointer" }}
                        onClick={() => dispatch(toggleSidebar())}
                      />
                    </span>
                  </Typography>
                  <Typography
                    variant="p"
                    sx={{
                      margin: "10px 0 10px",
                      display: "block",
                      fontWeight: 500,
                    }}
                  >
                    {JobpostingDetails?.clientName?.clientName}
                  </Typography>
                  <div className="actionLinks">
                     {JobpostingDetails?.location && (
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <AddressIcon style={{ flexShrink: 0, marginTop: "2px" }} />
                        <span style={{ fontSize: 14 }}>
                          {JobpostingDetails?.location}
                        </span>
                      </Box>
                    )}
                    </div>
                    <div className="actionLinks">
                    {JobpostingDetails?.payBillRate && (
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <img
                          src="/ats/assests/img/common_currency.svg"
                          alt=""
                          width="20px"
                        />
                        <span style={{ fontSize: 14 }}>
                          {JobpostingDetails?.payBillRate}
                        </span>
                      </Box>
                    )}
                  </div>
                </Box>
              )}
            </Box>

            {/* Actions */}
            {!Boolean(showEditJobDetails) && (
              <Box
                // sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0 }}
                sx={{
                  display: 'grid', justifyItems: 'self-end', rowGap: '18px',
                }}
              >
                  <IconButton
                    disableRipple
                    style={{
                      cursor: "pointer",
                      position: isSidebarHidden ? "absolute" : "static",
                      top: isSidebarHidden ? "105px" : "auto",
                      right: isSidebarHidden ? "53px" : "auto",
                    }}
                    onClick={() => {
                      if (!showEditJobDetails) {
                        onCloseHandler();
                      }
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    {/* <Tooltip title="Clone" placement="top">
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setOpen(true);
                        }}
                      >
                        <Clone />
                      </div>
                    </Tooltip>
                    <Tooltip title="Edit" placement="top">
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setShowEditJobDetails(true);
                        }}
                      >
                        <ApplicantEdit />
                      </div>
                    </Tooltip> */}
                    <FloatingMenu
                      config={{}}
                      floatingMenuOptions={{
                        ...JobpostingDetailsMenuOptions,
                        inline: JobpostingDetailsMenuOptions.inline.filter(
                          (opt) =>
                            opt.action !== "delete" ||
                            GetUserInfo()?.[0]?.systemroles === "Admin" ||
                            GetUserInfo()?.[0]?.systemroles === "Manager"
                        ),
                      }}
                      onReceiveActionHandler={onReceiveActionHandler}
                      storedTheme={storedTheme}
                    />
                  </Box>
              </Box>
            )}
          </Box>

          <Divider />

          {/* Stats Bar */}
          {JobpostingDetails && !Boolean(showEditJobDetails) && (
            <Box
              sx={{
                display: "flex",
                gap: 1.5,
                px: 2,
                py: 2.5,
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              {[
                {
                  icon: `${process.env.PUBLIC_URL}/assests/img/ActiveDaysIcon.svg`,
                  value: (() => {
                    const d = new Date(JobpostingDetails.createdAt);
                    const now = new Date();
                    return Math.floor((now - d) / (1000 * 60 * 60 * 24));
                  })(),
                  label: "Active Days",
                },
                {
                  icon: `${process.env.PUBLIC_URL}/assests/img/LastActivityIcon.svg`,
                  value: (() => {
                    const d = new Date(JobpostingDetails.updatedAt);
                    const now = new Date();
                    let mins = Math.floor((now - d) / 60000);
                    if (mins <= 0) mins = 0;
                    if (mins < 60) return `${mins} min${mins !== 1 ? "s" : ""} ago`;
                    const hrs = Math.floor(mins / 60);
                    if (hrs < 24) return `${hrs} hour${hrs !== 1 ? "s" : ""} ago`;
                    const days = Math.floor(hrs / 24);
                    return `${days} day${days !== 1 ? "s" : ""} ago`;
                  })(),
                  label: "Last Activity",
                },
                {
                  icon: `${process.env.PUBLIC_URL}/assests/img/SubmittedIcon.svg`,
                  value: accociatedApplicantList.filter(
                    (a) => a.status?.toLowerCase() === "submitted"
                  ).length,
                  label: "Submitted",
                },
                {
                  icon: `${process.env.PUBLIC_URL}/assests/img/AssociatedIcon.svg`,
                  value: accociatedApplicantList.filter(
                    (a) => a.status?.toLowerCase() !== "rejected" && a.status?.toLowerCase() !== "pending"
                  ).length,
                  label: "Associated",
                },
                {
                  icon: `${process.env.PUBLIC_URL}/assests/img/RejectedIcon.svg`,
                  value: accociatedApplicantList.filter(
                    (a) => a.status?.toLowerCase() === "rejected"
                  ).length,
                  label: "Rejected",
                },
              ].map((stat) => (
                <Box
                  key={stat.label}
                  sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    py: 1.5,
                    px: 1,
                    gap: 0.5,
                    border: "1px solid #e0e0e0",
                    borderRadius: "10px",
                    backgroundColor: "#FCFCFC",
                  }}
                >
                  <img src={stat.icon} alt={stat.label} width={24} height={24} />
                  <Typography fontWeight={700} fontSize={18} lineHeight={1.2}>
                    {stat.value}
                  </Typography>
                  <Typography fontSize={12} color="text.secondary" textAlign="center">
                    {stat.label}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}

          {/* Tabs */}
          {!Boolean(showEditJobDetails) && (
            <TabContext value={tab}>
              <Box>
                <TabList
                  onChange={(_, newValue) => {
                    onRenderComponentHandler("changeAppliant", newValue);
                    setTab(newValue);
                  }}
                  variant="scrollable"
                  scrollButtons="auto"
                  allowScrollButtonsMobile
                  sx={{
                    mt: 1,
                    px: 2,
                    "& .MuiTabs-flexContainer": {
                      flexWrap: "nowrap",
                    },
                    "& .MuiTab-root": {
                      textTransform: "none",
                      fontWeight: 500,
                      minWidth: "auto",
                      px: { xs: 1, sm: 2 },
                      fontSize: { xs: "12px", sm: "14px" },
                    },
                    "& .Mui-selected": {
                      bgcolor: storedTheme.primaryColor,
                      borderRadius: 5,
                      color: "#000 !important",
                    },
                  }}
                >
                  <Tab value="jobdetails" label="Job Details" />
                  <Tab
                    value="document"
                    label={`Documents (${document.length})`}
                  />
                  <Tab
                    value="associatedapplicants"
                    label={`Associated Applicants (${accociatedApplicantList.length})`}
                  />
                  <Tab value="portals" label="Portals" />
                  <Tab value="notes" label={`Notes (${notesData.length})`} />
                  <Tab
                    value="screeningquestions"
                    label={`Screening Questions (${questions.length})`}
                  />
                  <Tab value="auditinfo" label="Audit Info" />
                </TabList>
              </Box>
              <TabPanel value="jobdetails">
                {JobpostingDetails && (
                  <JobpostingDetailsOverview
                    selectedJob={savedJobPosting}
                    jobDetails={JobpostingDetails}
                  />
                )}
              </TabPanel>
              <TabPanel value="document">
                <div className="custom-dyanamic-table document-section">
                  <JobpostingDetailsDocuments
                    data={document}
                    selectedJob={savedJobPosting}
                    onReceiveProps={(type, object) => {
                      onRenderComponentHandler(type, object);
                    }}
                  />
                </div>
              </TabPanel>
              <TabPanel value="associatedapplicants">
                <div className={moduleType === "client" || moduleType === "projects" ? "custom-dyanamic-table associateSection fromClient" : "custom-dyanamic-table associateSection"}>
                  <JobpostingAssociatedApplicants
                    data={accociatedApplicantList}
                    selectedJobId={savedJobPosting}
                    selectedJobCode={savedJobCode}
                    onReceiveProps={(type) => {
                      onRenderComponentHandler(type);
                    }}
                  />
                </div>
              </TabPanel>
              <TabPanel value="portals">
                <div className="custom-dyanamic-table">
                  <JobpostingDetailsPortalsView
                    selectedJobId={savedJobPosting}
                  />
                </div>
              </TabPanel>
              <TabPanel value="notes">
                <div className="custom-dyanamic-table">
                  <JobpostingDetailsNotes
                    data={notesData}
                    selectedJobId={savedJobPosting}
                    onReceiveProps={(type) => {
                      onRenderComponentHandler(type);
                    }}
                  />
                </div>
              </TabPanel>
              <TabPanel value="screeningquestions">
                <div className="custom-dyanamic-table">
                  <ScreeningQuestions
                    isQuestionData={false}
                    jobDetailsID={savedJobPosting}
                    onReceiveData={onReceiveDataHandler}
                    getCreatedJob={JobpostingDetails}
                  />
                </div>
              </TabPanel>
              <TabPanel value="auditinfo">
                <div className="custom-dyanamic-table associateSection">
                  <JobpostingDetailsAuditlogging data={auditlogData} />
                </div>
              </TabPanel>
            </TabContext>
          )}
          {Boolean(showEditJobDetails) && (
            <JobpostingDetailsEdit
              jobDetailsID={savedJobPosting}
              input={JobpostingDetails}
              iniValue={JobpostingDetails}
              onReceiveProps={(type) => {
                onRenderComponentHandler(type);
                setTab("jobdetails");
              }}
            />
          )}
        </>
      )}
      <WarningPopup
        open={open}
        handleClose={() => setOpen(false)}
        handleConfirm={handleConfirmClone}
        details={warningPopups.CLONE_POPUP}
      />
      <WarningPopup
        open={showDeleteConfirm}
        handleClose={() => setShowDeleteConfirm(false)}
        handleConfirm={handleConfirmDelete}
        details={warningPopups.DELETE_POPUP}
      />
    </Box>
  );
};

export default JobpostingDetailsTabs;
